var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dots"},[_c('div',{staticClass:"one dot"}),_c('div',{staticClass:"two dot"}),_c('div',{staticClass:"three dot"})])}]

export { render, staticRenderFns }